<template>
    <div class="service-num-wrap">

        <ul class="service-num-list">
            <li class="service-num-item">
                <div class="goods-info">
                    <div class="goods-image">
                        <span v-if="shopDeviceSvcSubNo.imageUrl != null && shopDeviceSvcSubNo.imageUrl != ''">
                            <img :src="shopDeviceSvcSubNo.imageUrl"/>
                        </span>
                        <span v-else>
                            <img v-resc-url="'/image/noimg.jpg'"/>
                        </span>
                    </div>
                    <div class="goods-summary">
                        <p class="name font14">
                            <span class="mr10">资产描述全称</span>
                            <span class="value font-gray3">{{shopDeviceSvcSubNo.title}}</span>
                        </p>
                        <p class="num">
                            <span class="mr10">品牌</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.brandName}}</span>
                        </p>
                        <p class="num">
                            <span class="mr10">分类</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.catName}}</span>
                        </p>
                        <p class="num">
                            <span class="mr10">系统编号</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.tmpNo}}</span>
                        </p>
                        <p class="num">
                            <span class="mr10">服务子号</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.svcSubNo || '无'}}</span>
                        </p>
                        <p class="num">
                            <span class="mr10">批次号</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.batchNo || '无'}}</span>
                        </p>

                        <p class="num">
                            <span class="mr10">资产状态</span>
                            <span class="value font-red">{{deviceUseStateMap[shopDeviceSvcSubNo.useState]}}</span>
                        </p>
                        <p class="num">
                            <span class="mr10">单位</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.theUnit || '无'}}</span>
                        </p>
                        <!--<p class="num">-->
                        <!--<span class="mr10">在库</span>-->
                        <!--<span class="value font-red">{{shopDeviceSvcSubNo.inStock ? '是' : '否'}}</span>-->
                        <!--</p>-->
                        <!--<p class="num">-->
                        <!--<span class="mr10">在用</span>-->
                        <!--<span class="value font-red">{{shopDeviceSvcSubNo.inUse ? '是' : '否'}}</span>-->
                        <!--</p>-->
                        <p class="num">
                            <span class="mr10">需补码</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.tagMissing ? '是' : '否'}}</span>
                        </p>
                        <p class="num" v-if="shopDeviceSvcSubNo.tagMissing && shopDeviceSvcSubNo.tagMissCause != null">
                            <span class="mr10">需补码原因</span>
                            <span class="value font-red">{{shopDeviceSvcSubNo.tagMissCause}}</span>
                        </p>
                    </div>
                </div>
                <div class="simple-row">
                    <div class="right" v-if="shopDeviceSvcSubNo.retailerBizUnitId == scopeEntity.bizUnitId && shopDeviceSvcSubNo.leaseState == 0">
                        <!--<button v-if="shopDeviceSvcSubNo.inStock && !shopDeviceSvcSubNo.locked" @click="appDevice" class="swb-btn swb-btn-small">领用</button> 随领用一起修改 -->
                        <!--<button v-if="shopDeviceSvcSubNo.inUse" @click="returnDevice" class="swb-btn swb-btn-small">归还</button>-->
                        <button v-if="shopDeviceSvcSubNo.useState != start" @click="startDevice" class="swb-btn swb-btn-small">
                            <span>启用</span>
                        </button>
                        <button v-if="shopDeviceSvcSubNo.useState == start" @click="outageDevice" class="swb-btn swb-btn-small">
                            <span>停用</span>
                        </button>
                        <button v-if="shopDeviceSvcSubNo.state == normalValue" @click="setSate(shopDeviceSvcSubNo.id, true)" class="swb-btn swb-btn-small">
                            <span>故障</span>
                        </button>
                        <button v-if="shopDeviceSvcSubNo.state == failedValue" @click="setSate(shopDeviceSvcSubNo.id, false)" class="swb-btn swb-btn-small">
                            <span>取消故障</span>
                        </button>
                        <button v-if="!shopDeviceSvcSubNo.tagMissing" @click="setTagMissing(shopDeviceSvcSubNo, true)" class="swb-btn swb-btn-small">
                            <span>需补码</span>
                        </button>
                        <button v-if="shopDeviceSvcSubNo.tagMissing" @click="updateTagMissing(shopDeviceSvcSubNo.id, false)" class="swb-btn swb-btn-small">
                            <span>已补码</span>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import userApi from '../../api/user'
    import devcApi from '../../api/devc'
    import assetVchrApi from '../../api/assetVchr'
    //
    import { openComStaffMainForSelectDlg } from '../orgStruct/selectDlg';

    export default {
        name: 'swb-shop-device-svcSubNo-state-management',
        desc: '机构资产服务子号状态管理',
        props: ['tmpNo', 'currentComId'],
        data: function () {
            return {
                shopDeviceSvcSubNo: {},
                deviceUseStateMap: {},
                normalValue: null,
                failedValue: null,
                start: null,
                // 资产图片
                scopeEntity: {}
            }
        },
        created: function () {
            this.start = getEnumInfoWith('deviceUseState', 'name', 'Start').value;
            this.deviceUseStateMap = getEnumMap("deviceUseState", "value2text");
            this.normalValue = getEnumInfoWith('deviceState', 'name', 'Normal').value;
            this.failedValue = getEnumInfoWith("deviceState", "name", "Failed").value;
            this.getShopDeviceInfo();
            //
            this.getUserContext();
        },
        methods: {
            getUserContext: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    self.scopeEntity = result.data.scopeEntity;
                });
            },
            getShopDeviceInfo: function () {
                let self = this;
                let postData = {};
                postData.tmpNo = this.tmpNo;
                postData.containMgmt = true;
                postData.containAsset = true;
                postData.containMaint = true;
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceByTmpNo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let item = result.data || {};
                        if(!Utils.isNoB(item.devcMgmtAspkt)) {
                            item = Object.assign(item, item.devcMgmtAspkt);
                        }
                        if(!Utils.isNoB(item.devcAssetAspkt)) {
                            item = Object.assign(item, item.devcAssetAspkt);
                        }
                        if(!Utils.isNoB(item.devcMaintAspkt)) {
                            item = Object.assign(item, item.devcMaintAspkt);
                        }
                        //
                        self.shopDeviceSvcSubNo = Utils.merge({}, item);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            startDevice: function () {
                let self = this;
                let shopDeviceSvcSubNo = self.shopDeviceSvcSubNo;
                let id = shopDeviceSvcSubNo.id;
                let postData = {};
                postData.id = id;
                postData.useState = getEnumInfoWith('deviceUseState', 'name', 'Start').value;
                let theDlg = Vue.$showDialog({
                    title: "启用",
                    width: 580,
                    height: 300,
                    showCloseBtn: true,
                    template: '<div class="form-info">' +
                    '<div class="form-row">' +
                    '<div class="form-label">' +
                    '<label>启用日期</label>' +
                    '</div>' +
                    '<div class="form-value width-2x" v-if="initStateDate == null">' +
                    '<el-date-picker v-model="startDate" type="date"  format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>' +
                    '</el-option>' +
                    '</div>' +
                    '<div v-else> <span>{{startDate}}</span>' +
                    '</div>' +
                    '<div class="form-label">' +
                    '<label>入账方式</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    '<el-select v-model="acctEnterWay" clearable placeholder="请选择">' +
                    '<el-option v-for="item in acctEnterWayList" :key="item.value" :label="item.text" :value="item.value">' +
                    '</el-option>' +
                    '</el-select>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        startDate: shopDeviceSvcSubNo.startDate,
                        initStateDate: shopDeviceSvcSubNo.startDate,
                        acctEnterWayList: getEnumList("acctEnterWay"),
                        acctEnterWay: shopDeviceSvcSubNo.acctEnterWay
                    },
                    okClicked: function () {
                        if(Utils.isNoB(this.startDate)) {
                            MsgBox.warning("请填写启用日期");
                            return false;
                        }
                        postData.startDate = this.startDate.format('yyyy-MM-dd');
                        postData.acctEnterWay = this.acctEnterWay;
                        let theLoad = MsgBox.loading();
                        devcApi.updateShopDeviceStarted(postData, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                theDlg.close();
                                MsgBox.success("操作成功！");
                                //
                                self.getShopDeviceInfo();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    },
                    methods: {}
                });
            },
            outageDevice: function () {
                let self = this;
                this.$confirm('确定要停用吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let shopDeviceSvcSubNo = self.shopDeviceSvcSubNo;
                    let id = shopDeviceSvcSubNo.id;
                    let postData = {};
                    postData.id = id;
                    postData.useState = getEnumInfoWith('deviceUseState', 'name', 'Outage').value;
                    let theLoad = MsgBox.loading();
                    devcApi.updateShopDeviceStarted(postData, function (result) {
                        if(result.type === "info") {
                            theLoad.close();
                            MsgBox.success("操作成功！");
                            //
                            self.getShopDeviceInfo();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            appDevice: function () {
                let self = this;
                let shopDeviceSvcSubNo = self.shopDeviceSvcSubNo || {};
                let deviceSvcSubNoId = self.shopDeviceSvcSubNo.id;
                // 选择部门
                let params = {
                    bizUnitId: shopDeviceSvcSubNo.retailerBizUnitId,
                    defComId: self.currentComId,
                    isCom: false,
                };
                openComStaffMainForSelectDlg(params, function (result, comStaffDlg) {
                    let postData = {};
                    postData.deviceSvcSubNoId = deviceSvcSubNoId;
                    // 归还人信息
                    let theDlg = Vue.$showDialog({
                        title: "资产领用",
                        showCloseBtn: true,
                        width: 400,
                        height: 300,
                        template: '<div class="form-info">' +
                        '<div class="form-row">' +
                        '<div class="form-label">' +
                        '<label>是否自动申请</label>' +
                        '</div>' +
                        '<div class="form-value">' +
                        '<el-radio-group v-model="autoApplyState">' +
                        '<el-radio :label="true">是</el-radio>' +
                        '<el-radio :label="false">否</el-radio>' +
                        '</el-radio-group>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-row" v-if="autoApplyState">' +
                        '<div class="form-label">' +
                        '<label>是否自动审核</label>' +
                        '</div>' +
                        '<div class="form-value">' +
                        '<el-radio-group v-model="autoAuditPass">' +
                        '<el-radio :label="true">是</el-radio>' +
                        '<el-radio :label="false">否</el-radio>' +
                        '</el-radio-group>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                        data: {
                            autoApplyState: true,
                            autoAuditPass: true
                        },
                        methods: {},
                        okClicked: function () {
                            postData.departId = result.srcComId;
                            postData.departName = result.srcComName;
                            postData.staffId = result.id;
                            postData.staffName = result.name;
                            postData.autoApplyState = this.autoApplyState;
                            postData.autoAuditPass = this.autoAuditPass;
                            //
                            let theLoad = MsgBox.loading();
                            assetVchrApi.saveShopDeviceReceiveVoucher(postData, function (resultInfo) {
                                theLoad.hide();
                                if(resultInfo.type === "info") {
                                    comStaffDlg.close();
                                    MsgBox.success("领用成功！");
                                    //
                                    self.getShopDeviceInfo();
                                } else {
                                    MsgBox.warning(resultInfo.message);
                                }
                            });
                        }
                    });

                }, "领用人信息 - 选择");
            },
            returnDevice: function () {
                let self = this;
                let shopDeviceSvcSubNo = self.shopDeviceSvcSubNo || {};
                let deviceSvcSubNoId = self.shopDeviceSvcSubNo.id;
                // 选择部门
                let params = {
                    bizUnitId: shopDeviceSvcSubNo.retailerBizUnitId,
                    defComId: self.currentComId,
                    isCom: false,
                };
                openComStaffMainForSelectDlg(params, function (result, comStaffDlg) {
                    let theDlg = Vue.$showDialog({
                        title: "资产归还",
                        showCloseBtn: true,
                        width: 400,
                        height: 300,
                        template: '<div class="form-info">' +
                        '<div class="form-row">' +
                        '<div class="form-label">' +
                        '<label>是否自动申请</label>' +
                        '</div>' +
                        '<div class="form-value">' +
                        '<el-radio-group v-model="autoApplyState">' +
                        '<el-radio :label="true">是</el-radio>' +
                        '<el-radio :label="false">否</el-radio>' +
                        '</el-radio-group>' +
                        '</div>' +
                        '</div>' +
                        '<div class="form-row" v-if="autoApplyState">' +
                        '<div class="form-label">' +
                        '<label>是否自动审核</label>' +
                        '</div>' +
                        '<div class="form-value">' +
                        '<el-radio-group v-model="autoAuditPass">' +
                        '<el-radio :label="true">是</el-radio>' +
                        '<el-radio :label="false">否</el-radio>' +
                        '</el-radio-group>' +
                        '</div>' +
                        '</div>' +
                        '</div>',
                        data: {
                            autoApplyState: true,
                            autoAuditPass: true
                        },
                        methods: {},
                        okClicked: function () {
                            let postData = {};
                            postData.deviceSvcSubNoId = deviceSvcSubNoId;
                            postData.autoApplyState = this.autoApplyState;
                            postData.autoAuditPass = this.autoAuditPass;
                            // 归还人信息
                            postData.returnDepartId = result.srcComId;
                            postData.returnDepartName = result.srcComName;
                            postData.returnStaffId = result.id;
                            postData.returnStaffName = result.name;
                            //
                            let theLoad = MsgBox.loading();
                            assetVchrApi.saveShopDeviceReturnVoucher(postData, function (result) {
                                theLoad.hide();
                                if(result.type === "info") {
                                    comStaffDlg.close();
                                    MsgBox.success("归还成功！");
                                    //
                                    self.getShopDeviceInfo();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    });

                }, "归还人信息 - 选择");
            },
            setSate: function (id, failed) {
                let self = this;
                let postData = {};
                postData.id = id;
                let title = null;
                if(failed) {
                    postData.state = self.failedValue;
                    title = "此操作将资产标识为故障";
                } else {
                    postData.state = self.normalValue;
                    title = "此操作将取消资产故障";
                }
                this.$confirm(title + ', 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let theLoad = MsgBox.loading();
                    devcApi.updateShopDeviceState(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            //
                            MsgBox.success("操作成功！");
                            self.getShopDeviceInfo();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            setTagMissing(row, tagMissing){
                let self = this;
                Vue.$showDialog({
                    title: '需补码',
                    showCloseBtn: true,
                    width: 600,
                    height: 300,
                    template: '<div class="form-info">' +
                    '<div class="form-row">' +
                    '<div class="form-label">' +
                    '<label  class="required">需补码原因</label>' +
                    '</div>' +
                    '<div class="form-value width-2x">' +
                    ' <el-input type="textarea" placeholder="请输入补码原因" v-model="tagMissCause"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        tagMissCause: null
                    },
                    methods: {},
                    okClicked: function () {
                        if(Utils.isNoB(this.tagMissCause)) {
                            MsgBox.warning("请输入补码原因");
                            return false;
                        }
                        let postData = {};
                        postData.id = row.id;
                        postData.tagMissing = tagMissing;
                        postData.tagMissCause = this.tagMissCause;
                        let theLoad = MsgBox.loading();
                        devcApi.updateShopDeviceTagMissing(postData, function (result) {
                            theLoad.hide();
                            if(result.type === "info") {
                                MsgBox.success("操作成功！");
                                self.getShopDeviceInfo();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                });
            },
            updateTagMissing(id, tagMissing){
                let self = this;
                let title = "确定将此资产设置为已补码吗?";
                if(tagMissing) {
                    title = "确定将此资产设置为需补码吗?";
                }
                //弹出确认框
                this.$confirm(title, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    postData.tagMissing = tagMissing;
                    let theLoad = MsgBox.loading();
                    devcApi.updateShopDeviceTagMissing(postData, function (result) {
                        theLoad.hide();
                        if(result.type === "info") {
                            MsgBox.success("操作成功！");
                            self.getShopDeviceInfo();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceStateManagement.vue